import React, { useEffect, useRef, useState } from 'react'
import shaka from 'shaka-player'
import ShakaPlayer from './ShakaPlayer';
import PlayerSubscription from './PlayerSubscription'
import { withRouter } from 'react-router-dom'
import trackGa from '../../analytics';
import { useSelector } from 'react-redux';
import './ShakaVideoPlayer.css'

function ShakaVideoPlayer({
  videoInfo,
  access,
  onDismissPlayer,
  handlePlayNext,
  handleUpdateHistory,
  setShouldGetHistory,
  historyData,
  autoplay = false,
  handleEndHistory,
  ...otherProps
}) {
  const controllerRef = useRef(null);
  const videoPlayer = useRef()
  const [showClose, setShowClose] = useState(true)
  const [error, setError] = useState(false)
  const user = useSelector(state => state.auth && state.auth.user)

  useEffect(() => {
    return () => {
      videoPlayer.current && videoPlayer.current.destroy()
    };
  }, []);

  // send heartbeat when user start media for the first time
  useEffect(() => {
    const durationInSecond = videoInfo.duration * 60
    handleUpdateHistory(0, durationInSecond)
  }, [handleUpdateHistory, videoInfo])

  useEffect(() => {
    // Observe the shaka player control to show close button at the left top
    const intervalDismissBtn = setInterval(() => {
      const el = document.querySelector(".shaka-controls-container")
      const elState = el ? el.getAttribute("shown") : true
      setShowClose(elState)
    }, 500);

    return () => {
      clearInterval(intervalDismissBtn)
    };
  }, []);

  useEffect(() => {
    try {
      const {
      /** @type {shaka.Player} */ player,
      /** @type {shaka.ui.Overlay} */ ui,
      /** @type {HTMLVideoElement} */ videoElement,
        // /** @type {shaka.ui.Controls} */ controls,
      } = controllerRef.current;
      const { stream, drmToken } = access
      videoPlayer.current = player

      if (
        access.error &&
        access.error.response &&
        access.error.response.data &&
        access.error.response.data.error
      ) {
        return setError(access.error.response.data.error)
      }

      const uiConfig = {
        controlPanelElements: [
          "play_pause",
          "time_and_duration",
          "rewind",
          "fast_forward",
          "spacer",
          "mute",
          "volume",
          "fullscreen",
          "overflow_menu"
        ],
        overflowMenuButtons: [
          "captions",
          "quality",
          "language",
          "cast",
          "playback_rate"
        ]
      }
      ui.configure(uiConfig)

      async function loadAsset() {
        videoPlayer.current.configure({
          drm: {
            servers: { 'com.widevine.alpha': 'https://license.pallycon.com/ri/licenseManager.do' }
          },
        });
        videoPlayer.current.getNetworkingEngine().registerRequestFilter(function (type, request) {
          if (type === shaka.net.NetworkingEngine.RequestType.LICENSE) {
            request.headers['pallycon-customdata-v2'] = drmToken
          }
        });

        // Load an asset.
        await videoPlayer.current.load(stream);

        // sent event to firebase analytics
        const paramsGA = {
          contentType: videoInfo.type,
          videoID: videoInfo.id
        }

        trackGa('MediaPlayback', 'mediaLaunch', paramsGA, user)

        // Trigger play.
        videoElement.play();
      }

      loadAsset();

    } catch (error) {
      return setError({
        code: 'missing_video',
        message: 'Missing video asset to play.'
      })
    }
  }, [access, user, videoInfo]);

  if (error) {
    return <PlayerSubscription
      onDismissPlayer={onDismissPlayer}
      otherProps={otherProps}
      error={error}
    />
  }

  return (
    <>
      <div className="vjs-dismiss-btn-wrapper"
        onClick={onDismissPlayer}
        style={{ visibility: showClose ? 'visible' : 'hidden' }}>
        <i className='vjs-dismiss-player-icon' />
      </div>
      <div>
        <ShakaPlayer
          videoInfo={videoInfo}
          handlePlayNext={handlePlayNext}
          handleUpdateHistory={handleUpdateHistory}
          setShouldGetHistory={setShouldGetHistory}
          historyData={historyData}
          autoplay={autoplay}
          handleEndHistory={handleEndHistory}
          height="100vh"
          width="100vw"
          ref={controllerRef}
        />
      </div>
    </>
  )
}

export default withRouter(React.memo(ShakaVideoPlayer))